export enum RiskMapReports {
  RISK_MAPS_REPORTS_ARCHIVE,
  DANGEROUS_REGISTRY,
  RISK_MANAGEMENT_PLAN,
  ACK_WITH_RISK_MAPS,
  POSITIONS_WITHOUT_RISK_MAPS,
  RISK_MANAGEMENT_SYSTEM,
  SIZ,
}
